import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './ResourceLibraryPageTitle.module.scss';
import { VIDEO_PAGE_TITLES, VideoPageType } from '../../../constants/videoPage';

type ResourceLibraryPageTitleProps = {
  page: VideoPageType;
  children?: ReactNode;
};

const ResourceLibraryPageTitle = ({ page, children }: ResourceLibraryPageTitleProps) => {
  const { title, description } = VIDEO_PAGE_TITLES[page];

  return (
    <div className={classes.header}>
      <TitleWithDescription
        className={classes.title}
        titleFont="inherit"
        title={title}
        description={description}
      />
      {children}
    </div>
  );
};

export { ResourceLibraryPageTitle };
